import React from 'react';
import './EnterpriseFeatures.css';

// Import your feature images (adjust the paths if you store them elsewhere)
import Feature1 from '@assets/LandingPage/EnterpriseFeatures/Rocket.png';
import Feature2 from '@assets/LandingPage/EnterpriseFeatures/Advance.png';
import Feature3 from '@assets/LandingPage/EnterpriseFeatures/Security.png';
import Feature4 from '@assets/LandingPage/EnterpriseFeatures/Team.png';
import Feature5 from '@assets/LandingPage/EnterpriseFeatures/GlobalTracking.png';
import Feature6 from '@assets/LandingPage/EnterpriseFeatures/GlobalScale.png';

const EnterpriseFeatures = () => {
  const features = [
    {
      id: 1,
      image: Feature1,
      title: 'Enterprise LMS',
      description:
        'Complete learning management system with admin controls, user management, and comprehensive reporting.',
    },
    {
      id: 2,
      image: Feature2,
      title: 'Advanced Analytics',
      description:
        'Deep insights into learning patterns, progress tracking, and ROI measurement with real-time dashboards.',
    },
    {
      id: 3,
      image: Feature3,
      title: 'Security & Compliance',
      description:
        'Enterprise-grade security with SSO, data encryption, and compliance with GDPR, SOC 2, and ISO standards.',
    },
    {
      id: 4,
      image: Feature4,
      title: 'Team Collaboration',
      description:
        'Foster teamwork with discussion forums, peer reviews, group projects, and social learning features.',
    },
    {
      id: 5,
      image: Feature5,
      title: 'Global Tracking',
      description:
        'Track learner progress across regions, time zones, and departments with unified reporting.',
    },
    {
      id: 6,
      image: Feature6,
      title: 'Global Scale',
      description:
        'Built to scale from hundreds to millions of users with 99.9% uptime and high-performance infrastructure.',
    },
  ];

  return (
    <div className="landing-enterprise-wrapper">
      <div className="landing-enterprise-container">
        <div className="landing-enterprise-header">
          <span className="landing-enterprise-badge">Enterprise Features</span>
          <h1>Everything Your Team Needs</h1>
          <p className="landing-enterprise-subtitle">
            Comprehensive learning platform designed for enterprise-scale training and development with
            cutting-edge technology.
          </p>
        </div>

        <div className="landing-enterprise-features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="landing-enterprise-feature-card">
              {/* ----- IMAGE WRAPPER ----- */}
              <div className="landing-enterprise-icon-wrapper">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="landing-enterprise-feature-icon"
                />
              </div>

              <div className="landing-enterprise-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>

              <div className="landing-enterprise-link">
                <a href="#" className="landing-enterprise-learn-more">
                  <span style={{ textDecoration: 'underline' }}>Learn More</span> →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseFeatures;